export default __webpack_public_path__ + "static/media/lorealTW.20fc0ac5.png";